export default "__VITE_ASSET__CfZ4Ogmi__"